import { get } from "./apiHelper";
import {
  INVENTORY_DASHBOARD,
  INVENTORY_BALANCE,
  INVENTORY_LEDGER,
  INVENTORY_AVAILABILITY,
} from "../config";

export const fetchInventoryDashboard        = async ()   => get(INVENTORY_DASHBOARD);
export const fetchInventoryBalance          = async ()   => get(INVENTORY_BALANCE);
export const fetchInventoryLedger           = async ()   => get(INVENTORY_LEDGER);
export const fetchInventoryAvailability     = async ()   => get(INVENTORY_AVAILABILITY);
export const fetchInventoryAvailabilityById = async (id) => get(`${INVENTORY_AVAILABILITY}/${id}`);
